import { render } from "./person-military-attachment.vue?vue&type=template&id=bfb69cb0"
import script from "./person-military-attachment.vue?vue&type=script&lang=js"
export * from "./person-military-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__